import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 14\" id=\"icon-sort\">\n<g>\n\t<polygon fill=\"#9FA0A0\" points=\"2.5,5.953 7,1.832 11.5,5.953 \t\" />\n\t<polygon fill=\"#9FA0A0\" points=\"11.5,8.047 6.999,12.168 2.5,8.047 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol